import { ApolloClient, InMemoryCache } from '@apollo/client';

import { createAppSyncHybridLink } from './appSyncHybridLink';
import { getToken } from './asyncUtils';

const createAppSyncApolloClient = async ({
  appSyncApiUrl,
  appSyncApiWsUrl,
  getJwtToken,
  cacheConfig,
  connectToDevTools,
}: any) =>
  new ApolloClient({
    link: await createAppSyncHybridLink({
      appSyncApiUrl,
      appSyncApiWsUrl,
      getJwtToken,
    }),
    cache: new InMemoryCache(cacheConfig),
    connectToDevTools,
  });

export const clientPromise = createAppSyncApolloClient({
  appSyncApiUrl: process.env.REACT_APP_APOLLO_URI,
  appSyncApiWsUrl: process.env.REACT_APP_APOLLO_WS_URI,
  getJwtToken: getToken,
});
